import { SET_MAP_LINK } from '../actions/types';

const mapLink = (state = '', { type, payload }) => {
	switch (type) {
		case SET_MAP_LINK:
			return payload || state;
		default:
			return state;
	}
};

export default mapLink;



// WEBPACK FOOTER //
// ./src/reducers/mapLink.js